<div class="mb-3">

  <div class="fs-4 mb-2" >Typ nové rezervace</div>
  <div class="btn-group" role="group">

    <ng-container *ngFor="let type of types; let i=index">

      <ng-container *ngIf="i===0">

      <input type="radio" name="type" (click)="changeType(type.id)" value="{{type.id}}" class="btn-check" id="btnradio{{type.id}}" autocomplete="off" checked>
      <label class="btn btn-outline-light" for="btnradio{{type.id}}">{{type.name}}</label>

      </ng-container>
      <ng-container *ngIf="i > 0">

        <input type="radio" name="type" (click)="changeType(type.id)" value="{{type.id}}" class="btn-check" id="btnradio{{type.id}}" autocomplete="off" disabled>
        <label class="btn btn-outline-light disabled" for="btnradio{{type.id}}" ngbPopover="Připravujeme od září 2022" triggers="mouseenter:mouseleave">{{type.name}}</label>

      </ng-container>

    </ng-container>

  </div>

</div>

<div *ngIf="this.type !== ''" class="pb-6">

  <div class="d-flex justify-content-between mb-4">

    <div><button (click)="prevMonth()" class="btn btn-outline-light"><</button></div>
    <div class="fs-4">{{monthName}}</div>
    <div><button (click)="nextMonth()" class="btn btn-outline-light">></button></div>

  </div>

  <div class="calendar-grid mb-3">

    <div class="single-day">Po</div>
    <div class="single-day">Út</div>
    <div class="single-day">St</div>
    <div class="single-day">Čt</div>
    <div class="single-day">Pá</div>
    <div class="single-day">So</div>
    <div class="single-day">Ne</div>

  </div>

  <div class="calendar-grid">

    <ng-container *ngFor="let item of ' '.repeat( startDay ).split(''), let i = index ">

      <div class="single-date">

      </div>

    </ng-container>

    <ng-container *ngFor="let day of this.days">

      <div class="single-date" (click)="onSelectDay(day)">
        <div class="single-date-btn" [class.selected]="compareDays(this.currentDay, day)">{{dateNumber(day)}}</div>
        <div *ngIf="findFree(day) !== 0"><div class="single-date-badge">{{findFree(day)}}</div></div>
      </div>

    </ng-container>

  </div>

</div>
